import { useMemo } from 'react';

import useOffers from 'api/useOffers';
import { Offer } from 'common/contracts';
import { OfferType } from 'constants/enums';

export interface IUseProgressBarOffersReturn {
  progressBarOffers: Offer[];
  isLoading: boolean;
}

/**
 * Loads all progress bar offers (`OfferType.PROGRESS_BAR`) and returns them
 * as a list, alongside a loading flag. Used by offer-creation forms to share
 * the bar list with both `BarPointsForm` (dropdown) and the preview
 * (so the preview can resolve the assigned bar's `accumulatedItem`).
 *
 * @example
 * const { progressBarOffers, isLoading } = useProgressBarOffers();
 * // pass progressBarOffers to OfferProgressBarSection and to the preview
 */
export const useProgressBarOffers = (): IUseProgressBarOffersReturn => {
  const { getOffers } = useOffers({
    offerType: OfferType.PROGRESS_BAR
  });

  const progressBarOffers = useMemo<Offer[]>(
    (): Offer[] => getOffers.data?.offers ?? [],
    [getOffers.data]
  );

  return {
    progressBarOffers,
    isLoading: getOffers.isLoading
  };
};

export default useProgressBarOffers;
